import { Box, Typography } from '@mui/material'
import GISSolutionsCard from 'src/components/GISSolutions/GISSolutionsCard'
import { gisSolutions } from 'src/components/GISSolutions/enums'

const GISSolutions = () => {
  return (
    <Box
      sx={{
        py: 5,
      }}
    >
      <Typography
        variant="h5"
        fontWeight="500"
        sx={{
          mb: 5,
          textAlign: 'center',
          borderBottom: `2px solid #000`,
          width: 'fit-content',
          mx: 'auto',
        }}
      >
        GIS Solutions
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
        {gisSolutions.map((solution, index) => (
          <GISSolutionsCard {...solution} key={index} />
        ))}
      </Box>
    </Box>
  )
}

export default GISSolutions
